import {
  PMPHeaderDoctorText,
  PMPHeaderLeftPart,
  PMPHeaderRightPart,
  PMPHeadingBanner,
} from '../../PrescriptionMakingPageStyles'
import PrescriptionKVItem from '../common/PrescriptionKVItem'

export default function TwoColumnPrescriptionHeader({ prescriptionData, leaveSpace, debug }) {
  return (
    <>
      <PMPHeadingBanner debug={debug} noColor={true}>
        <span>{prescriptionData?.header?.title}</span>
        {/* {prescriptionData?.header?.subTitle && ( */}
        <span className="sub-heading">{prescriptionData?.header?.subTitle}</span>
        {/* )} */}
      </PMPHeadingBanner>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <PMPHeaderLeftPart>
          <PMPHeaderDoctorText main>{prescriptionData?.doctorName}</PMPHeaderDoctorText>
          <PMPHeaderDoctorText>{prescriptionData?.designation}</PMPHeaderDoctorText>
          <PMPHeaderDoctorText>{prescriptionData?.listOfDegrees?.join(', ')}</PMPHeaderDoctorText>
          {prescriptionData?.contactEmail && (
            <PMPHeaderDoctorText>
              <PrescriptionKVItem itemKey="Email" value={prescriptionData?.contactEmail} />
            </PMPHeaderDoctorText>
          )}
          {prescriptionData?.website && (
            <PMPHeaderDoctorText>
              <PrescriptionKVItem itemKey="Website" value={prescriptionData?.website} />
            </PMPHeaderDoctorText>
          )}
        </PMPHeaderLeftPart>
        <PMPHeaderRightPart
          style={{
            flexShrink: 0,
            width: 'unset',
          }}
        >
          {prescriptionData?.regId && (
            <PMPHeaderDoctorText>
              <PrescriptionKVItem
                itemKey="Regn No."
                topContainerProps={{
                  className: 'd-flex align-items-center justify-content-end gap-1',
                }}
                value={prescriptionData?.regId}
              />
            </PMPHeaderDoctorText>
          )}
          {prescriptionData?.cmoRegId && (
            <PMPHeaderDoctorText>
              <PrescriptionKVItem
                itemKey="C.M.O. Regd. No."
                topContainerProps={{
                  className: 'd-flex align-items-center justify-content-end gap-1',
                }}
                value={prescriptionData?.cmoRegId}
              />
            </PMPHeaderDoctorText>
          )}
          {prescriptionData?.affiliations?.map((affiliation, affIndex) => (
            <PMPHeaderDoctorText key={affIndex}>
              <b>{affiliation}</b>
            </PMPHeaderDoctorText>
          ))}
        </PMPHeaderRightPart>
      </div>
    </>
  )
}
